export const PENDING_DEFAULTS_HEADER_CLASS =
  'align-middle [&_button]:max-w-full [&_button]:whitespace-normal [&_button]:leading-tight [&_button_span]:whitespace-normal'

export type { ConfiguredReportColumn } from '../../types/pages'
